import {defineStore} from 'pinia'
import DataSource from "devextreme/data/data_source";
import { ref} from "vue";
import {useKgbPrediksiListModel} from "@/stores/models/kgb-prediksi-list-model";

export const useKgbPrediksiListStore  = defineStore(
    'kgbPrediksiListStore',
    () => {
       
        const isLoading = ref(false);
        const dataSourceKgbPrediksiList = ref(
            new DataSource({
                requireTotalCount: true,
                store: useKgbPrediksiListModel().kgbPrediksiListCustomStore,
                filter: null,
            })
        );
        const state = ref(true);
        const onMuatButtonClick =()=>{
            state.value = false;
            dataSourceKgbPrediksiList.value.reload();
        };

        const dataSourceKgbPrediksiListArray = (additionalParamsFilter = null, additionalParamsSort = null) => {
            return useKgbPrediksiListModel().kgbPrediksiListArray(additionalParamsFilter, additionalParamsSort);
        };

        const dataSourceKgbPrediksiListUpdate = (key = null, values = null) => {
            return useKgbPrediksiListModel().kgbPrediksiListUpdate(key, values);
        };

        const tetapkan = (key = null) => {
            return useKgbPrediksiListModel().kgbPrediksiTetapkan(key);
        }

        const sinkron = (key = null) => {
            return useKgbPrediksiListModel().kgbPrediksiSinkron(key);
        }


        const initialized = ()=>{     
            dataSourceKgbPrediksiList.value.reload();
        };

        return {
            tetapkan,
            sinkron,
            dataSourceKgbPrediksiListUpdate,
            dataSourceKgbPrediksiListArray,
            dataSourceKgbPrediksiList,
            isLoading,
            onMuatButtonClick,
            initialized,
            state

        }
    }
);